import { isEmail } from "utils";

const validateName = (dealer: any) => {
    let isValid = false
    if (dealer?.dealerName === undefined || dealer?.dealerName === "" || dealer?.dealerName === null || dealer?.dealerName?.trim()?.length == 0) {
        dealer.dealerNameError = "Please enter name";
    } else if (dealer?.dealerName?.length > 50) {
        dealer.nameError = "Please enter name less than 50 characters";
    } else {
        dealer.dealerNameError = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateContact = (dealer: any) => {
    let isValid = false
    if (dealer?.dealerContact === undefined || dealer?.dealerContact === "" || dealer?.dealerContact === null || dealer?.dealerContact?.trim()?.length == 0) {
        dealer.dealerContactError = "Please enter contact";
    } else if (dealer?.dealerContact?.length > 100) {
        dealer.dealerContactError = "Please enter Contact less than 100 characters";
    } else {
        dealer.dealerContactError = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validatePhone = (dealer: any) => {
    let isValid = false
    let phoneVal = dealer?.dealerPhone?.match(/\d/g);
    if (dealer?.dealerPhone == "" || dealer?.dealerPhone == undefined || dealer?.dealerPhone == undefined || phoneVal === null || phoneVal.length < 10 || phoneVal?.toString().trim()?.length == 0) {
        dealer.dealerPhoneError = "Please enter valid phone";
    } else {
        dealer.dealerPhoneError = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateEmail = (dealer: any) => {
    let isValid = false
    const emailRegex = isEmail(dealer?.dealerEmail);
    if (dealer?.dealerEmail === undefined || dealer?.dealerEmail === "" || dealer?.dealerEmail === null || emailRegex) {
        dealer.dealerEmailError = "Please enter valid email address";
    } else if (dealer?.dealerEmail?.length > 50) {
        dealer.dealerEmailError = "Please enter Email Address less than 50 characters";
    } else {
        dealer.dealerEmailError = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateAddressLine1 = (dealer: any) => {
    let isValid = false
    if (dealer?.dealerAdd1 === undefined || dealer?.dealerAdd1 === "" || dealer?.dealerAdd1 === null || dealer?.dealerAdd1?.trim()?.length == 0) {
        dealer.dealerAdd1Error = "Please enter address line 1";
    } else if (dealer?.dealerAdd1?.length > 200) {
        dealer.dealerAdd1Error = "Please enter Address Line 1 less than 200 characters";
    } else {
        dealer.dealerAdd1Error = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateAddressLine2 = (dealer: any) => {
    let isValid = false
    if (dealer?.dealerAdd2?.length > 200) {
        dealer.dealerAdd2Error = "Please enter Address Line 2 less than 200 characters";
    } else {
        dealer.dealerAdd2Error = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateAddressLine3 = (dealer: any) => {
    let isValid = false
    if (dealer?.dealerAdd3?.length > 200) {
        dealer.dealerAdd3Error = "Please enter Address Line 3 less than 200 characters";
    } else {
        dealer.dealerAdd3Error = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateDealerCity = (dealer: any) => {
    let isValid = false
    if (dealer.dealerCity === undefined || dealer.dealerCity === "" || dealer.dealerCity === null || dealer?.dealerCity?.trim()?.length == 0) {
        dealer.dealerCityError = "Please enter city";
    } else if (dealer?.dealerCity?.length > 100) {
        dealer.dealerCityError = "Please enter City less than 100 characters.";
    } else {
        dealer.dealerCityError = "";
        isValid = true;
    }
    return { isValid, dealer };
}

const validateDealerState = (dealer: any) => {
    let isValid = false
    if (dealer.dealerState === undefined || dealer.dealerState === "" || dealer.dealerState === null || dealer?.dealerState?.trim()?.length == 0) {
        dealer.dealerStateError = "Please enter state";
    } else if (dealer?.dealerState?.length > 2) {
        dealer.dealerStateError = "Please enter state code in 2 characters.";
    }
    else {
        dealer.dealerStateError = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateZip = (dealer: any) => {
    let isValid = false
    if (dealer.dealerZip === undefined || dealer.dealerZip === "" || dealer.dealerZip === null || dealer?.dealerZip?.trim()?.length == 0) {
        dealer.dealerZipError = "Please enter zip code";
    } else if (dealer.dealerZip?.length > 10) {
        dealer.dealerZipError = "Please enter zip code less than 10 digits.";
    } else {
        dealer.dealerZipError = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateQuotePrice = (dealer: any) => {
    let quotePriceValue = dealer?.quotePrice ? dealer?.quotePrice?.toString()?.replace(/,/g, "") : ''
    let isValid = false
    if (dealer.quotePrice === undefined || dealer.quotePrice === "" || dealer.quotePrice === null || dealer?.quotePrice == "0.00" || dealer?.quotePrice == 0) {
        dealer.quotePriceError = "Please enter quote price";
    } else if (quotePriceValue?.length > 18) {
        dealer.quotePriceError = "Please enter quote price less than 17 digits";
    } else {
        dealer.quotePriceError = "";
        isValid = true
    }
    return { isValid, dealer };
}

const validateDealer = (dealer: any) => {
    let isValid = true;    

    let validationResponse = {dealer: dealer, isValid: true}

        validationResponse = validateQuotePrice(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateName(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateContact(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validatePhone(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateEmail(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateAddressLine1(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateAddressLine2(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateAddressLine3(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateDealerCity(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateDealerState(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }

        validationResponse = validateZip(validationResponse.dealer)
        if (!validationResponse.isValid) {
            isValid = false;
        }
    let reasonTemp = validationResponse;
    reasonTemp.isValid = isValid;
    return reasonTemp;
}

export default {
    validateName,
    validateContact,
    validatePhone,
    validateEmail,
    validateAddressLine1,
    validateAddressLine2,
    validateAddressLine3,
    validateDealerCity,
    validateDealerState,
    validateZip,
    validateDealer,
    validateQuotePrice
}

